import { TableModule } from "@/component/common/report/reportConfigModel"
import React from 'react'
import normal from './images/icon_sort_white_small_null@2x.png'
import asc from './images/icon_sort_white_small_asc@2x.png'
import desc from './images/icon_sort_white_small_desc@2x.png'
import { SortParams,SortOrder,SortOrderParams } from "@/component/common/report/report"
import styled from "styled-components"



const  TableListHeaderView = styled.div`
  .list{
    display: flex;
    background-color: #f4f4f4;
    padding:0 15px;
    .empty{
      flex:1;
    }
    .item{
      display: flex;
      align-items: center;
      height: 50px;
      img{
        width: 15px;
        height: 15px;
      }
    }
  }



`




const sortIcons:Record<keyof typeof SortOrder|"normal",string> =  {
  normal: normal,
  ascend: asc,
  descend: desc
}
type Sort = keyof typeof sortIcons

interface TableListHeaderProps {
  sortField: Array<{label:string,value:string}>
  sorts:Array<{
    field: string,
    order?:  SortOrderParams
  }>
  onChange(field:string,sort?:keyof typeof SortOrder):void
}



export function TableListHeader(props:TableListHeaderProps){
  const { sortField,sorts } =  props
  if(!sortField.length){
    return null
  }
  const onChange = (value:string,sort?:SortOrderParams)=>{
    let newSort:keyof typeof SortOrder|undefined = undefined
    switch(sort){
      case SortOrder.ascend:
        newSort = SortOrder.descend
        break
      case SortOrder.descend:
        newSort = undefined
        break
      case undefined:
        newSort = SortOrder.ascend
        break
      default:
        break
    }
    props.onChange(value,newSort)
  }
  return <TableListHeaderView>
    <div className="list">
      {
        sortField.map((item,index) => {
          let icon = sortIcons.normal
          let currentSort = sorts.find(sort => sort.field == item.value)
          if (currentSort) {
            let sortType = currentSort.order
            icon = sortType ? sortIcons[sortType] : sortIcons.normal
          }
          return <>
            <div className="item" onClick={() => onChange(item.value, currentSort?.order)} key={item.value}>
              {item.label}
              <img src={icon} />
            </div>
            {index+1 == sortField.length ? null : <div className="empty"></div> }
          </>
        })
      }
    </div>
  </TableListHeaderView>
}